<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="1"
      [md]="1"
      [lg]="1"
    ></dxo-col-count-by-screen>
    <dxi-item class="uploader">
      <div *dxTemplate>
        <form-photo-uploader></form-photo-uploader>
      </div>
    </dxi-item>
  </dxi-item>

  <dxi-item itemType="group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="2"
      [md]="2"
      [lg]="2"
    ></dxo-col-count-by-screen>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          label="First Name"
          [(value)]="newUser.firstName"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          label="Last Name"
          [(value)]="newUser.lastName"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          label="Company"
          [(value)]="newUser.company"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          label="Position"
          [(value)]="newUser.position"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
  </dxi-item>

  <dxi-item itemType="group" cssClass="contact-fields-group">
    <dxo-col-count-by-screen
      [xs]="1"
      [sm]="2"
      [md]="2"
      [lg]="2"
    ></dxo-col-count-by-screen>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          label="Assigned to"
          [(value)]="newUser.manager"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          icon="tel"
          label="Phone"
          mask="+1(000)000-0000"
          [(value)]="newUser.phone"
          [isEditing]="true"
        >
        </form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          icon="email"
          label="Email"
          [(value)]="newUser.email"
          [validators]="[{ type: 'email' }, { type: 'required' }]"
          [isEditing]="true"
        ></form-textbox>
      </div>
    </dxi-item>
    <dxi-item>
      <div *dxTemplate>
        <form-textbox
          icon="home"
          label="Address"
          [(value)]="newUser.address"
          [isEditing]="true"
        ></form-textbox>
      </div>
    </dxi-item>
  </dxi-item>
</dx-form>
